<main id="main-content" class="main-content">
    <h2 class="form-header">WO Approval & Certification</h2>

    <mat-card>
        <h2 class="forest-title">WO Line Officer(s)</h2>
        <div *ngIf="regionContacts.length > 0">
            <div class="contact-container">
                <mat-card *ngFor="let user of regionContacts" class="contact-card">
                    <div>
                        <div class="user-cell-name">
                            <div class="user-icon">
                                <p>{{user.first_name[0]}}</p>
                            </div>
                            <a [routerLink]="['/user']" [queryParams]="{user_id: user?.user_id}"
                                class="user-name">{{user.first_name + " " + user.last_name}}</a>
                        </div>
                        <div class="user-cell-details">
                            <mat-chip *ngFor="let role of user.showRoles">{{ role }}</mat-chip>
                            <div class="details-number"><mat-icon>phone</mat-icon> {{(user.phone_num | phone) ||
                                "--"}}
                            </div>
                            <div class="details-email"><mat-icon>email</mat-icon>{{user.email}}</div>
                            <div class="details-email"><mat-icon>location_on</mat-icon>Washington Office</div>
                        </div>
                    </div>
                </mat-card>
            </div>
        </div>
    </mat-card>
</main>